(function () {
  if (window.__bigKiddoSaleInit) {
    return;
  }
  window.__bigKiddoSaleInit = true;

  var OLD_TEXTS = [
    "🥳 Our Anniversary Sale Is Live Now! 🥳",
    "🥳 Our Anniversary Sale Is On! 🥳",
    "🥳 Anniversary Sale is On! 🥳"
  ];

  var NEW_TEXT = "🤸🎈The Big Kiddo Sale is now LIVE ! 🎈👩🏼‍🤝‍👨🏽";

  var SELECTOR = "h1,h2,h3,h4,h5,h6,#seasonalSale";

  var NORMALIZED_OLD = [];
  var observer = null;
  var queued = false;

  function normalize(value) {
    return String(value)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  for (var n = 0; n < OLD_TEXTS.length; n++) {
    NORMALIZED_OLD.push(normalize(OLD_TEXTS[n]));
  }

  function isOldText(el) {
    var text = normalize(el.textContent);
    for (var i = 0; i < NORMALIZED_OLD.length; i++) {
      if (NORMALIZED_OLD[i] === text) {
        return true;
      }
    }
    return false;
  }

  function swap(el) {
    if (!isOldText(el)) {
      return;
    }

    var textNodes = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (normalize(node.nodeValue) !== "") {
        textNodes.push(node);
      }
    }

    if (observer) {
      observer.disconnect();
    }

    if (textNodes.length === 0) {
      el.textContent = NEW_TEXT;
    } else {
      textNodes[0].nodeValue = NEW_TEXT;
      for (var j = 1; j < textNodes.length; j++) {
        textNodes[j].nodeValue = "";
      }
    }

    if (observer) {
      connect();
    }
  }

  function scan(root) {
    var scope = root || document;

    if (scope.nodeType === 1 && scope.matches && scope.matches(SELECTOR)) {
      swap(scope);
    }

    if (scope.querySelectorAll) {
      var nodes = scope.querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        swap(nodes[i]);
      }
    }
  }

  function queueScan() {
    if (queued) {
      return;
    }
    queued = true;

    var run = function () {
      queued = false;
      scan();
    };

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run);
    } else {
      setTimeout(run, 16);
    }
  }

  function connect() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function start() {
    scan();

    if (!window.MutationObserver || !document.body) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var type = mutations[i].type;
        if (type === "childList" || type === "characterData") {
          queueScan();
          return;
        }
      }
    });

    connect();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();